export default __webpack_public_path__ + "static/statkraft-c677330260434e731572e9df914a86dd.png";